<body>
  <app-loading></app-loading>
  <app-toast></app-toast>
  <router-outlet/>
</body>
